module.exports = __webpack_public_path__ + "static/media/project_pending.8c420811.svg";